// extracted by mini-css-extract-plugin
module.exports = {"hover-block":"hover-block___X43vU","duplicate":"duplicate____o1TV"};